import { TChartValues, TIntersection, TIntersectionersectFn } from '../../types'

export const getIntersectionColor = (
	intersection: TIntersection,
	isLast?: boolean,
) => {
	if (isLast) {
		return intersection.line1isHigherNext ? '#D05151' : '#2FBF69'
	}

	return intersection.line1isHigher ? '#D05151' : '#2FBF69'
}

export const getDataWithRange = (data: TChartValues[]) =>
	data.map(d => ({
		...d,
		range:
			d.before !== undefined && d.after !== undefined
				? [d.before, d.after]
				: [],
	}))

export const getIntersections = (data: TChartValues[]) =>
	data
		.map((d, i) =>
			intersect(
				i,
				d.before,
				i + 1,
				data[i + 1]?.before,
				i,
				d.after,
				i + 1,
				data[i + 1]?.after,
			),
		)
		.filter(d => d && !isNaN(d.x))

const intersect: TIntersectionersectFn = (x1, y1, x2, y2, x3, y3, x4, y4) => {
	// Check if none of the lines are of length 0
	if ((x1 === x2 && y1 === y2) || (x3 === x4 && y3 === y4)) {
		return false
	}

	const denominator = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1)

	// Lines are parallel
	if (denominator === 0) {
		return false
	}

	let ua = ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) / denominator
	let ub = ((x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3)) / denominator

	// is the intersection along the segments
	if (ua < 0 || ua > 1 || ub < 0 || ub > 1) {
		return false
	}

	// Return a object with the x and y coordinates of the intersection
	let x = x1 + ua * (x2 - x1)
	let y = y1 + ua * (y2 - y1)

	const line1isHigher = y1 > y3
	const line1isHigherNext = y2 > y4

	return { x, y, line1isHigher, line1isHigherNext }
}

export const tickFormat = (value: any) => {
	if (Number(value) < -1000)
		return `-$${String(Math.abs(+value)).slice(0, -3)}K`
	if (Number(value) > 1000) return `$${String(value).slice(0, -3)}K`
	else return `$${value}`
}